var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCube = function SvgCube(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "m9.91 21.67-5.24-3A4.17 4.17 0 0 1 2.58 15V9a4.17 4.17 0 0 1 2.09-3.64l5.24-3a4.16 4.16 0 0 1 4.18 0l5.24 3A4.17 4.17 0 0 1 21.42 9v6a4.17 4.17 0 0 1-2.09 3.61l-5.24 3a4.16 4.16 0 0 1-4.18.06",
    opacity: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M20.86 6.89a4.1 4.1 0 0 0-1.53-1.53l-5.24-3a4.16 4.16 0 0 0-4.18 0l-5.24 3a4.1 4.1 0 0 0-1.53 1.53L12 12z",
    opacity: 0.3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M20.85 6.89 12 12l.13 10.22a4.2 4.2 0 0 0 2-.55l5.24-3A4.17 4.17 0 0 0 21.42 15V9a4.16 4.16 0 0 0-.57-2.11"
  })));
};
export default SvgCube;